import React from 'react';
import { Radio, Tv, Archive, CalendarDays, Shield } from 'lucide-react';
import { LANDING_SECTION_VALUE_PILLARS, LANDING_VALUE_PILLARS } from '../../landing/landingCopy';

const PILLAR_ICONS = [Radio, Archive, CalendarDays, Shield, Tv] as const;

const LscLandingValuePillars: React.FC = () => {
  return (
    <section className="space-y-8" data-testid="lsc-landing-value-pillars">
      <div className="text-center space-y-3">
        <h2 className="text-2xl md:text-3xl font-bold text-white">{LANDING_SECTION_VALUE_PILLARS}</h2>
        <p className="text-secondary-400 max-w-2xl mx-auto">
          League Stream Center sells the broadcast experience members feel on game day.
        </p>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {LANDING_VALUE_PILLARS.map(({ title, description }, index) => {
          const Icon = PILLAR_ICONS[index] ?? Tv;
          return (
            <article
              key={title}
              className="group rounded-xl border border-secondary-700/80 bg-gradient-to-b from-secondary-800/70 to-secondary-900/80 p-5 space-y-4 shadow-lg transition duration-200 hover:-translate-y-1 hover:border-primary-700/40 hover:shadow-primary-950/20"
              data-testid="lsc-landing-value-pillar"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary-900/40 text-primary-300 ring-1 ring-primary-700/30">
                <Icon className="h-5 w-5" aria-hidden />
              </span>
              <h3 className="text-lg font-semibold text-white">{title}</h3>
              <p className="text-sm text-secondary-400 leading-relaxed">{description}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default LscLandingValuePillars;
